import { Container, makeStyles, Typography } from '@material-ui/core'
import React from 'react'
import banner from "../Banner/banner2.jpg";
import Carousel from './Carousel';
const useStyles =makeStyles(()=>({
    banner:{
        backgroundImage: `url(${banner})`,
    },
    bannerContent:{
        height:400,
        display:"flex",
        flexDirection:"column",
        paddingTop:25,
        justifyContent:"space-around",
    },
    tagline:{
        display:"flex",
        height:"40%",
        flexDirection:"column",
        justifyContent:"center",
        textAlign:"center",
    }
}))
const Banner = () => {
    const classes =useStyles();
    return (
        <div className={classes.banner}>
            <Container className={classes.bannerContent}>
                <div className={classes.tagline}>
                    <Typography
                        variant="h2"
                        style={{
                            fontWeight:"bold",
                            marginBottom:15,
                            fontFamily:"Montserrat",
                            color:"white",
                        }}>
                        OwnCrypto
                    </Typography>
                    <Typography
                        variant="subtitle2"
                        style={{
                            color:"darkgrey",
                            textTransform:"capitalize",
                            fontFamily:"Montserrat",
                        }}>
                        Get to know about all crypto's here and customize
                    </Typography>
                    
                </div>
                <Carousel/>
            </Container>
        </div>
    )
}

export default Banner
